import { FBN_LOOKBACK_DAYS, FBN_SEARCH_URL } from '../../../shared/fields';
import { btn, linkBtn } from '../ui/components';
import { h } from '../ui/dom';

/** The import screen's county steps (D76): the filings the bookmark opened, waiting for the rep's go, and
 *  what came of them. The flow itself is importPlanChecks.ts. */

const inboxButton = () =>
  linkBtn('Open New businesses', '#/signals', { variant: 'primary', size: 'lg', class: 'w-full' });

export const COUNTY_BACK = { href: FBN_SEARCH_URL, label: "Back to the county's search" };
export const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`;

/** The county's filings the bookmark opened (D76), waiting for the rep's go like the plan checks. */
export const countyConfirmStep = (filings: number, onImport: () => void, note?: string): HTMLElement[] => [
  h(
    'div',
    { class: 'section' },
    h('h2', { class: 'section__title' }, `${plural(filings, 'filing')} to check`),
    h(
      'p',
      { class: 'card__summary' },
      `From the county's business-name search, the last ${FBN_LOOKBACK_DAYS} days: the filings whose names say storefront, opened in your browser.`,
    ),
    note ? h('p', { class: 'card__summary' }, note) : null,
  ),
  btn(`Import ${plural(filings, 'filing')}`, {
    variant: 'primary',
    size: 'lg',
    class: 'w-full',
    onClick: onImport,
  }),
];

export const countyResultStep = (
  r: { received: number; kept: number; inserted: number; pending: number },
  note?: string,
): HTMLElement[] => [
  h(
    'div',
    { class: 'section' },
    h('h2', { class: 'section__title' }, r.inserted ? `${r.inserted} new to review` : 'Nothing new'),
    h(
      'p',
      { class: 'card__summary' },
      note ??
        [
          `${plural(r.received, 'filing')} · ${r.kept} checked · ${r.inserted} new storefronts`,
          r.pending ? `${r.pending} waiting for Google to list them` : null,
        ]
          .filter(Boolean)
          .join(' · '),
    ),
  ),
  inboxButton(),
];
